module.exports = __webpack_public_path__ + "img/5.a0cab9ed.png";